export default {
    createExamFormAndHallTicket: '/examFormAndHallTicket/create',
    getExamFormAndHallTicket :'/examFormAndHallTicket/getExamFormAndHallTicket'
    // getExams: '/newExam/getExams',
    // getExam: '/newExam/getExam',
    // deleteExam: '/newExam/deleteExam'
}
